import * as core from '../../../../../../../core'

export const RESOURCE = {
  payload: {
    alias: 'projects',
    content: {
      root: {
        elements: [
          {
            content: {
              row: {
                elements: [
                  {
                    content: {
                      widget: {
                        widget: {
                          alias: 'projects-table',
                        },
                      },
                    },
                    span: 12,
                  },
                ],
              },
            },
            height: 300,
          },
        ],
      },
    },
    description: 'Projects Page',
    name: 'Projects',
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicPage,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicPage>
